import { render } from "./PrintDocument.vue?vue&type=template&id=5c53055e&scoped=true&ts=true"
import script from "./PrintDocument.vue?vue&type=script&lang=ts"
export * from "./PrintDocument.vue?vue&type=script&lang=ts"

import "./PrintDocument.vue?vue&type=style&index=0&id=5c53055e&scoped=true&lang=css"

import exportComponent from "/builds/weleaf/twd-origination-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c53055e"]])

export default __exports__